module.exports = __webpack_public_path__ + "img/AW_Logo_Provider ID_Final.2affcb7c.png";